import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState({
      lang: state => state.core.lang,
      builder: state => state.builder,
      site: state => state.builder.site,
    })
  }
});

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys()
  .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true;
    }

    return { ...modules, [name]: module };
  }, {});

export default new Vuex.Store({
  modules,
  state: {
    user: Cookies.get('user'),
    pn:['home','page 1']
  },
  getters: {
    user: state => state.auth.user,
    page_names : state => {
      return state.pn;
    }
  },
});
